import {
    Centrifuge,
    ConnectionTokenContext,
    SubscriptionTokenContext,
} from 'centrifuge';
import { getCSRFToken } from './csrf';

const isSubscriptionTokenContext = (
    ctx: ConnectionTokenContext | SubscriptionTokenContext,
): ctx is SubscriptionTokenContext => {
    return (ctx as SubscriptionTokenContext).channel !== undefined;
};

async function getToken(
    ctx: ConnectionTokenContext | SubscriptionTokenContext,
): Promise<string> {
    const res = await fetch('/api/centrifugo/token', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-XSRF-TOKEN': getCSRFToken(),
        },
        body: JSON.stringify({
            channel: isSubscriptionTokenContext(ctx) ? ctx.channel : undefined,
        }),
        credentials: 'include',
    });

    if (!res.ok) {
        if (res.status === 403) {
            throw new Centrifuge.UnauthorizedError('Error fetching token: Unauthorized');
        }
        throw new Error(`Unexpected status code ${res.status}`);
    }
    const data = await res.json();
    return data.token as string;
}

let instance: Centrifuge | null = null;

function getCentrifuge(wsUrl: string): Centrifuge {
    if (instance) return instance;

    instance = new Centrifuge(`${wsUrl}/connection/websocket`, { getToken });
    instance.connect();
    return instance;
}

export function subscribeToChannel(
    wsUrl: string,
    channel: string,
    callback: (data: any) => void,
): () => void {
    const client = getCentrifuge(wsUrl);

    const sub =
        client.getSubscription(channel) ??
        client.newSubscription(channel, { getToken });

    sub.on('publication', (ctx) => {
        callback(ctx.data);
    }).subscribe();

    return () => {
        sub.unsubscribe();
    };
}
